export const organizations = {
  tr: {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        'url': 'https://www.enuygun.com/',
        'logo': 'https://cdn2.enuygun.com/media/lib/uploads/image/enuygun-logo-12638.jpeg',
        'name': 'Enuygun',
        'alternateName': ['Enuygun.com'],
        'sameAs': [
          'https://www.facebook.com/enuygun',
          'https://x.com/enuygun',
          'https://www.instagram.com/enuygun',
          'https://www.youtube.com/enuyguncom',
          'https://tr.linkedin.com/company/wingieenuygungroup',
        ],
        'description': 'Uçak bileti, otel, otobüs bileti, araç kiralama ve transfer gibi hizmetler sunan lider seyahat platformu',
        'slogan': "Türkiye'nin Seyahat Sitesi!",
        'address': {
          '@type': 'PostalAddress',
          'streetAddress': 'Küçükbakkalköy Mah. Kayışdağı Cd. Allianz Tower 1/16 34750 Ataşehir İstanbul',
          'addressLocality': 'İstanbul',
          'addressCountry': 'TR',
        },
        'telephone': '+90-850-333-88-88',
        'email': 'bilgi@enuygun.com',
        'contactPoint': {
          '@type': 'ContactPoint',
          'contactType': 'Customer Service',
          'telephone': '+90-850-333-88-88',
          'email': 'bilgi@enuygun.com',
        },
        'foundingDate': '2008-01-01',
        'founder': {
          '@type': 'Person',
          'name': 'Çağlar Erol',
        },
        'numberOfEmployees': '350',
        'areaServed': 'Türkiye',
      },
      {
        '@type': 'WebSite',
        'url': 'https://www.enuygun.com/',
        'name': 'Enuygun',
      },
    ],
  },
  az: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'Enuygun',
    'alternateName': ['Enuygun.com'],
    'url': 'https://www.wingie.az/',
    'logo': 'https://cdn2.enuygun.com/media/lib/uploads/image/enuygun-logo-12638.jpeg',
    'sameAs': ['https://www.facebook.com/enuygun', 'https://x.com/enuygun', 'https://www.instagram.com/enuygun'],
  },
  us: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'Wingie',
    'alternateName': ['Wingie.com'],
    'url': 'https://www.wingie.com/',
    'logo': 'https://cdn2.enuygun.com/media/lib/uploads/image/49692.png',
    'sameAs': ['https://www.facebook.com/wingiecom', 'https://www.instagram.com/wingiecom/', 'https://twitter.com/WingieCOM'],
  },
  gb: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'Wingie',
    'alternateName': ['Wingie.co.uk'],
    'url': 'https://www.wingie.co.uk/',
    'logo': 'https://cdn2.enuygun.com/media/lib/uploads/image/49692.png',
    'sameAs': ['https://www.facebook.com/wingiecom', 'https://www.instagram.com/wingiecom/', 'https://twitter.com/WingieCOM'],
  },
  de: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'Wingie',
    'alternateName': ['Wingie.de'],
    'url': 'https://www.wingie.de/',
    'logo': 'https://cdn2.enuygun.com/media/lib/uploads/image/49692.png',
    'sameAs': ['https://www.facebook.com/wingiecom', 'https://www.instagram.com/wingiecom/', 'https://twitter.com/WingieCOM'],
  },
  es: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'Wingie',
    'alternateName': ['Wingie.es'],
    'url': 'https://www.wingie.es/',
    'logo': 'https://cdn2.enuygun.com/media/lib/uploads/image/49692.png',
    'sameAs': ['https://www.facebook.com/wingiecom', 'https://www.instagram.com/wingiecom/', 'https://twitter.com/WingieCOM'],
  },
  ae: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'Wingie',
    'alternateName': ['Wingie.ae'],
    'url': 'https://www.wingie.ae/',
    'logo': 'https://cdn2.enuygun.com/media/lib/uploads/image/49692.png',
    'sameAs': ['https://www.facebook.com/Wingie-Arabia-101778389095927', 'https://www.instagram.com/wingiearabia/', 'https://twitter.com/wingiearabia'],
  },
  sa: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'Wingie',
    'alternateName': ['sa.wingie.com'],
    'url': 'https://sa.wingie.com/',
    'logo': 'https://cdn2.enuygun.com/media/lib/uploads/image/49692.png',
    'sameAs': ['https://www.facebook.com/Wingie-Arabia-101778389095927', 'https://www.instagram.com/wingiearabia/', 'https://twitter.com/wingiearabia'],
  },
  ru: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'Wingie',
    'alternateName': ['ru.wingie.com'],
    'url': 'https://ru.wingie.com/',
    'logo': 'https://cdn2.enuygun.com/media/lib/uploads/image/49692.png',
    'sameAs': ['https://www.facebook.com/wingiecom', 'https://www.instagram.com/wingiecom/', 'https://twitter.com/WingieCOM'],
  },
  pl: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'Wingie',
    'alternateName': ['www.wingie.pl'],
    'url': 'https://www.wingie.pl/',
    'logo': 'https://cdn2.enuygun.com/media/lib/uploads/image/49692.png',
    'sameAs': ['https://www.facebook.com/wingiecom', 'https://www.instagram.com/wingiecom/', 'https://twitter.com/WingieCOM'],
  },
  it: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'Wingie',
    'alternateName': ['www.wingie.it'],
    'url': 'https://www.wingie.it/',
    'logo': 'https://cdn2.enuygun.com/media/lib/uploads/image/49692.png',
    'sameAs': ['https://www.facebook.com/wingiecom', 'https://www.instagram.com/wingiecom/', 'https://twitter.com/WingieCOM'],
  },
  fr: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'Wingie',
    'alternateName': ['www.wingie.fr'],
    'url': 'https://www.wingie.fr/',
    'logo': 'https://cdn2.enuygun.com/media/lib/uploads/image/49692.png',
    'sameAs': ['https://www.facebook.com/wingiecom', 'https://www.instagram.com/wingiecom/', 'https://twitter.com/WingieCOM'],
  },
  eg: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'Wingie',
    'alternateName': ['eg.wingie.com'],
    'url': 'https://eg.wingie.com/',
    'logo': 'https://cdn2.enuygun.com/media/lib/uploads/image/49692.png',
    'sameAs': ['https://www.facebook.com/Wingie-Arabia-101778389095927', 'https://www.instagram.com/wingiearabia/', 'https://twitter.com/wingiearabia'],
  },
  iq: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'Wingie',
    'alternateName': ['iq.wingie.com'],
    'url': 'https://iq.wingie.com/',
    'logo': 'https://cdn2.enuygun.com/media/lib/uploads/image/49692.png',
    'sameAs': ['https://www.facebook.com/Wingie-Arabia-101778389095927', 'https://www.instagram.com/wingiearabia/', 'https://twitter.com/wingiearabia'],
  },
  ma: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'Wingie',
    'alternateName': ['ma.wingie.com'],
    'url': 'https://ma.wingie.com/',
    'logo': 'https://cdn2.enuygun.com/media/lib/uploads/image/49692.png',
    'sameAs': ['https://www.facebook.com/Wingie-Arabia-101778389095927', 'https://www.instagram.com/wingiearabia/', 'https://twitter.com/wingiearabia'],
  },
  ge: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'Wingie',
    'alternateName': ['ge.wingie.com'],
    'url': 'https://ge.wingie.com/',
    'logo': 'https://cdn2.enuygun.com/media/lib/uploads/image/49692.png',
    'sameAs': ['https://www.facebook.com/wingiecom', 'https://www.instagram.com/wingiecom/', 'https://twitter.com/WingieCOM'],
  },
}
